var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "go-icon_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "95.71%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBB10A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go-icon_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "95.71%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBB10A"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "go-icon_svg__b",
    cx: 9.034,
    cy: 9,
    rx: 9.034,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "go-icon_svg__d",
    cx: 9.034,
    cy: 9,
    rx: 7.743,
    ry: 7.714
  }), /*#__PURE__*/React.createElement("filter", {
    id: "go-icon_svg__e",
    width: "112.9%",
    height: "113%",
    x: "-6.5%",
    y: "-6.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.603921569 0 0 0 0 0.443137255 0 0 0 0 0.0588235294 0 0 0 0.459776947 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "go-icon_svg__f",
    d: "M11.633 7.569c.656 0 .984.387.984 1.16 0 .816-.325 1.225-.975 1.225-.682 0-1.023-.398-1.023-1.193 0-.38.088-.673.266-.88.178-.208.427-.312.748-.312zM9.356 8.831c0 .729.213 1.305.64 1.73.426.425 1.012.637 1.758.637.757 0 1.353-.219 1.789-.657.435-.438.653-1.035.653-1.79 0-.698-.211-1.26-.634-1.685-.422-.425-1.004-.637-1.747-.637-.754 0-1.352.212-1.795.637-.443.425-.664 1.013-.664 1.765zm-3.313.822c-.176-.201-.264-.474-.264-.819 0-.401.093-.713.278-.933.185-.221.44-.332.763-.332a.93.93 0 01.958.946v.327c0 .334-.093.603-.28.807a.947.947 0 01-.733.305c-.306 0-.546-.1-.722-.301zM5.06 7.07c-.362.429-.543 1.007-.543 1.736 0 .65.163 1.168.488 1.554.326.387.766.58 1.321.58.598 0 1.05-.24 1.355-.723h.017v.34c0 .407-.124.728-.373.965-.25.237-.6.355-1.054.355-.456 0-.907-.129-1.355-.386v1.117c.343.165.807.248 1.394.248.886 0 1.563-.22 2.03-.658.467-.438.7-1.056.7-1.855v-3.81H7.7v.5h-.017c-.264-.403-.66-.605-1.19-.605-.592 0-1.07.214-1.432.642z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#go-icon_svg__a)",
    xlinkHref: "#go-icon_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#go-icon_svg__c)",
    xlinkHref: "#go-icon_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#go-icon_svg__e)",
    xlinkHref: "#go-icon_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#846418",
    xlinkHref: "#go-icon_svg__f"
  }))));
}
export default SvgGoIcon;